const API_BASE_URL = 'https://rutasbusmen.geovoy.com/api/v1';
const OSRM_API = 'https://router.project-osrm.org/route/v1/driving';

export default {
  // Fetch rutas del API
  async getRoutes(company = 'Alpezzi TP') {
    try {
      const response = await fetch(`${API_BASE_URL}/rutasParadas`, {
        method: 'POST',
        body: new URLSearchParams(`grupo=${company}`),
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching routes:', error);
      throw error;
    }
  },

  // Obtener geometría de ruta desde OSRM
  async getRoadRoute(coordinates, routeId = '') {
    if (coordinates.length < 2) {
      throw new Error('Se necesitan al menos 2 coordenadas');
    }

    // Fallback para rutas largas
    if (coordinates.length > 30) {
      return {
        type: 'LineString',
        coordinates: [...coordinates],
      };
    }

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000);

    try {
      const coordsString = coordinates
        .map((coord) => `${coord[0]},${coord[1]}`)
        .join(';');

      const response = await fetch(
        `${OSRM_API}/${coordsString}?overview=full&geometries=geojson`,
        { signal: controller.signal },
      );

      clearTimeout(timeoutId);

      if (!response.ok) {
        throw new Error(`OSRM HTTP ${response.status}`);
      }

      const data = await response.json();

      if (data.routes && data.routes.length > 0) {
        return data.routes[0].geometry;
      }

      // Fallback a línea recta
      return {
        type: 'LineString',
        coordinates: [...coordinates],
      };
    } catch (error) {
      clearTimeout(timeoutId);
      // eslint-disable-next-line no-console
      console.warn(`OSRM error for route ${routeId}:`, error.message);

      // Fallback a línea recta
      return {
        type: 'LineString',
        coordinates: [...coordinates],
      };
    }
  },
};
